import { Text } from 'blaze-ui/Text/Text'
import Styles from './MetricValue.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { formatValue } from 'screens/blaze/Home/components/Analytics/utils'
import { useId } from '@react-aria/utils'

interface MetricValueProps {
  name: string
  value: number | null
  type: 'absolute' | 'percentage'
  rate?: 'positive' | 'negative' | 'neutral'
}

export const getPercentageColor = (rate: 'positive' | 'negative' | 'neutral' | undefined) => {
  if (rate === 'positive') {
    return 'var(--green-50)'
  } else if (rate === 'negative') {
    return 'var(--red-50)'
  }
  return 'var(--dark-80)'
}

const renderText = ({ type, value, rate }: Omit<MetricValueProps, 'name'>) => {
  if (value === null) return ''
  let rendered

  if (type === 'percentage') rendered = `${value?.toFixed(0)}%`
  else {
    rendered = `${formatValue(value)}`
  }

  if (rate === 'positive') {
    rendered = `+${rendered}`
  }

  return rendered
}

export const MetricValue = ({ name, value, type, rate }: MetricValueProps) => {
  const id = useId()
  return (
    <div className={Styles.metricValue}>
      <ResponsiveDesign.Mobile>
        <Text variant="placeholder" color="var(--dark-80)" id={id}>
          {name}
        </Text>
        <Text variant="label" color={getPercentageColor(rate)} aria-labelledby={id}>
          {value === null ? (
            <Text variant="placeholder" color="var(--dark-40)">
              No data
            </Text>
          ) : (
            renderText({ type, value, rate })
          )}
        </Text>
      </ResponsiveDesign.Mobile>

      <ResponsiveDesign.Desktop>
        <Text variant="metadata" color="var(--dark-60)" id={id}>
          {name}
        </Text>
        <Heading level={4} color={getPercentageColor(rate)} aria-labelledby={id}>
          {value === null ? (
            <Text variant="placeholder" color="var(--dark-40)">
              No data
            </Text>
          ) : (
            renderText({ type, value, rate })
          )}
        </Heading>
      </ResponsiveDesign.Desktop>
    </div>
  )
}
